import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { handleKeyPress } from "../../../utils/handleKeyPress";
import { FormInputText } from "../../form-components/form-input-text";
import { createPlacementPrebidConfigurations } from "../apiService";

const PlacementPrebidConfigurationsAddPlacementForm = ({
  prebidAccountId,
  onClose,
  setSnackbar,
}) => {
  // Initializes form
  const { control, handleSubmit } = useForm({
    defaultValues: {
      placement_ids: "",
      prebid_rev_share: 30,
      weight: 50,
    },
  });

  // // Initializes QueryClient
  const queryClient = useQueryClient();

  const createPlacementPrebidConfiguratiosnMutation = useMutation({
    mutationFn: createPlacementPrebidConfigurations,
    onSuccess: (params) => {
      if (params["success"] === false) {
        setSnackbar({
          children: params["error_messages"],
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Placements successfully added",
          severity: "success",
        });
        queryClient.invalidateQueries({
          queryKey: ["PlacementPrebidConfigurations"],
        });
        onClose();
      }
    },
  });

  const submitForm = (data) => {
    data["prebid_account_id"] = prebidAccountId;
    createPlacementPrebidConfiguratiosnMutation.mutate(data);
  };

  return (
    <form
      onSubmit={handleSubmit(submitForm)}
      data-testid="add-placement-prebid-configuration-form"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInputText
            name="placement_ids"
            control={control}
            label="Placement Ids"
            customValidation={(value) => {
              if (!value) {
                return "Value must not be empty.";
              }

              // it should validate that the value exists
              // and that is a comma separated list of integers
              // it can accept a comma in the end

              const placementIds = value.split(",");

              //allow the last item to be empty
              if (placementIds[placementIds.length - 1] === "") {
                placementIds.pop();
              }

              const areIntegers = placementIds.every((placementId) => {
                const intValue = parseInt(placementId, 10);
                return !isNaN(intValue);
              });

              if (!areIntegers) {
                return "Value must be a comma separated list of integers.";
              }
              return true;
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInputText
            name="prebid_rev_share"
            control={control}
            label="Prebid Hypr Rev Share"
            onKeyPress={handleKeyPress(99)}
            customValidation={(value) => {
              const intValue = parseInt(value, 10);
              if (isNaN(intValue) || intValue < 0 || intValue >= 100) {
                return "The value should be greater than or equal to 0 and less than 100";
              }
              return true;
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormInputText
            name="weight"
            control={control}
            label="Traffic Allocation to Prebid"
            onKeyPress={handleKeyPress(100)}
            customValidation={(value) => {
              const intValue = parseInt(value, 10);
              if (isNaN(intValue) || intValue < 0 || intValue > 100) {
                return "Please enter a value between 0 and 100";
              }
              return true;
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" type="submit">
            ADD PLACEMENTS
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default PlacementPrebidConfigurationsAddPlacementForm;
